// BookingForm.jsx
import React, { useContext } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  OutlinedInput,
  Select,
  MenuItem
} from "@mui/material";
import { StyledBox, StyledTypography } from "../../../assets/css/styledComponent";
import { UserContext } from "../../../components/auth/auth-context";

const BookingForm = ({ questions, answers, errors, onAnswerChange, answerData, staff }) => {
  const { providerUser } = useContext(UserContext);

  const renderQuestionInput = (question) => {
    const title = question.title;
    const answerValue = answers[question.id] || [""];
    const errorForQuestion = errors[question.id];

    if (question.type.toLowerCase().includes("radio")) {
      return (
        <>
          <RadioGroup
            value={answerValue[0]}
            onChange={(e) => onAnswerChange(question.id, e.target.value, false)}
          >
            {answerData
              ?.getInviteeAnswers.filter((ans) => Number(ans.questionId) === Number(question.id))
              .map((ans) => (
                <FormControlLabel
                  key={ans.id}
                  value={ans.title}
                  control={<Radio />}
                  label={ans.title}
                />
              ))}
          </RadioGroup>
          {errorForQuestion && (
            <StyledBox className="error-message" style={{ color: "red" }}>
              Please select an option.
            </StyledBox>
          )}
        </>
      );
    } else if (question.type.toLowerCase().includes("checkbox")) {
      return (
        <StyledBox>
          {answerData
            ?.getInviteeAnswers.filter((ans) => Number(ans.questionId) === Number(question.id))
            .map((ans) => (
              <FormControlLabel
                key={ans.id}
                value={ans.title}
                control={
                  <Checkbox
                    checked={(answers[question.id] || []).includes(ans.title)}
                    onChange={() => onAnswerChange(question.id, ans.title, true)}
                  />
                }
                label={ans.title}
              />
            ))}
          {errorForQuestion && (
            <StyledBox className="error-message" style={{ color: "red" }}>
              Please select an option.
            </StyledBox>
          )}
        </StyledBox>
      );
    } else if (question.type.toLowerCase().includes("drop")) {
      return (
        <Select
          fullWidth
          value={answerValue[0]}
          onChange={(e) => onAnswerChange(question.id, e.target.value, false)}
        >
          {answerData
            ?.getInviteeAnswers.filter((ans) => Number(ans.questionId) === Number(question.id))
            .map((ans) => (
              <MenuItem key={ans.id} value={ans.title}>
                {ans.title}
              </MenuItem>
            ))}
        </Select>
      );
    } else {
      // Determine default value for email or name
      const defaultValue =
        title.toLowerCase() === "email"
          ? providerUser.email
          : title.toLowerCase() === "name"
          ? providerUser.username
          : "";
      const isOwnAccount = Number(providerUser.staffId) === Number(staff.staffId);

      const isDisabled =
            !isOwnAccount && (
              (title.toLowerCase() === "email" && providerUser.email) ||
          (title.toLowerCase() === "name" && providerUser.username)
        );


      return (
        <OutlinedInput
          onChange={(e) => onAnswerChange(question.id, e.target.value, false)}
          value={answerValue[0] || defaultValue}
          multiline={question.type.toLowerCase().includes("multi")}
          variant="outlined"
          sx={{ width: "100%", maxWidth: "500px" }}
          error={!!errorForQuestion}
          disabled={isDisabled}
        />
      );
    }
  };

  return (
    <StyledBox
      sx={{
        flex: 2,
        padding: "30px",
        paddingRight: "20px",
        overflow: "auto",
        gap: "10px",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <StyledTypography fontSize="20px">Enter Your Details</StyledTypography>
      {questions?.map((question) => (
        <StyledBox key={question.id}>
          <StyledBox sx={{ display: "flex", alignItems: "center" }}>
            <h4 className="input-label">
            {`${question.title} ${(question.required && question.title.toLowerCase() !== "email" && question.title.toLowerCase() !== "phone number") ? "*" : ""}`}

            </h4>
          </StyledBox>
          {renderQuestionInput(question)}
        </StyledBox>
      ))}
    </StyledBox>
  );
};

export default BookingForm;
